import React from "react";
import { Switch, Route, useRouteMatch } from "react-router-dom";
import { Provider } from "react-redux";

import photoModStore from "./store";

// components
import ProtectedRoutes from "./ProtectedRoutes/index";
import HomePage from "./pages/HomePage";
import VisualQueuePage from "./pages/VisualQueuePage";
import SuspendedQueuePage from "./pages/SuspendedQueuePage";
import CompletedQueuePage from "./pages/CompletedQueuePage";
import MetadataQueuePage from "./pages/MetadataQueuePage";

import { usePhotoModWebSocket } from "./hooks";

export const PhotoModUnwrapped = () => {
    usePhotoModWebSocket();
    const { path } = useRouteMatch();

    return (
        <Switch>
            <ProtectedRoutes>
                <Route exact path={path}>
                    <HomePage />
                </Route>
                <Route path={`${path}/visual-queue`}>
                    <VisualQueuePage />
                </Route>
                <Route path={`${path}/metadata-queue`}>
                    <MetadataQueuePage />
                </Route>
                <Route path={`${path}/completed-queue`}>
                    <CompletedQueuePage />
                </Route>
                {/* hide route until suspended queue is ready to work on again */}
                {/* <Route path={`${path}/suspended-queue`}>
                    <SuspendedQueuePage />
                </Route> */}
            </ProtectedRoutes>
        </Switch>
    );
};

const PhotoMod = () => (
    <Provider store={photoModStore}>
        <PhotoModUnwrapped />
    </Provider>
);

export default PhotoMod;
